import React from 'react'
import { DOC_TYPE_INFO } from '@constants/articles/docTypes'

function HTMLContent ({ html, docType = null, onMobile, h1 }) {
    html = html || fromDocType(docType, onMobile, h1)
    return (
        <section className="container"
            dangerouslySetInnerHTML={{ __html: html }} />
    )
}

function fromDocType (docType, onMobile, h1) {
    return `<h1 style="font-size:32rem;margin:10px 0;${onMobile?"text-align:center":""}">${ h1 || DOC_TYPE_INFO[docType].heading }</h1>`
}

export default HTMLContent